import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { BaseLayerComponent } from "../base-layer/base-layer.component";
import { Component, Input } from "@angular/core";

@Component({
  template: "",
  standalone: false,
})
export abstract class WmsLayerComponent extends BaseLayerComponent {
  hide = true;

  isLoading = false;

  layers: any[];

  isAuthRequired: string;

  @Input()
  url = "";

  urlType: string;

  username: string;

  password: string;

  changed: boolean = true;

  form = new FormGroup({
    username: new FormControl(""),
    password: new FormControl(""),
  });

  newLayerForm = new FormGroup({
    newWMSLayerName: new FormControl(""),
    newWMSLayerOpacity: new FormControl(75),
  });

  protected constructor(
    // @Inject(MAT_LEGACY_DIALOG_DATA) protected data: IDialogData,
    // @Inject(MAT_LEGACY_DIALOG_DATA) protected url: string,
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected matDialog: MatDialog,
  ) {
    super(http, viewerConfigurationService, matDialog);
  }

  onAuthRequireChange(event: any) {
    this.isAuthRequired = event.value;
    this.changed = true;
    document.getElementById("lblError").innerHTML = "";
  }

  changeInput() {
    this.changed = true;
  }

  fieldsCompleted() {
    if (this.isAuthRequired) {
      return this.form.get("username").value !== "" && this.form.get("password").value !== "" && this.changed;
    }

    return this.changed;
  }

  usernameExists() {
    return this.form.get("username").value.length > 0;
  }

  passwordExists() {
    return this.form.get("password").value.length > 0;
  }

  getCapabilitiesSuccess(data: Object) {
    let capability;
    const formatter = this.getWMSFormatter();
    try {
      const response = formatter.read(data);

      // this object contains all the GetCapabilities data
      capability = response.Capability;
    } catch (e) {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "Bad data was returned";
      return;
    }
    if (!capability || !capability.Layer) {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "No layers were returned";
      return;
    }
    this.layers = capability.Layer.Layer;
    this.isLoading = false;
    this.changed = true;
    this.cdr.detectChanges();
    this.loadLayers();
  }

  getCapabilitiesError() {
    this.isLoading = false;
    this.cdr.detectChanges();
    document.getElementById("lblError").innerHTML = "Failed to load url";
  }

  getLayerInformation() {
    document.getElementById("lblError").innerHTML = "";
    this.changed = false;
    this.isLoading = true;
    this.username = this.form.get("username").value;
    this.password = this.form.get("password").value;
    let { url } = this;
    url +=
      url.indexOf("?") > -1
        ? "&service=wms&version=1.0.0&request=GetCapabilities"
        : "?service=wms&version=1.0.0&request=GetCapabilities";

    let credentials;
    if (this.isAuthRequired && this.username && this.username.length && this.password && this.password.length) {
      credentials = `${this.username}:${this.password}`;
    }
    this.getCapabilities(url, credentials);
  }

  abstract loadLayers();

  abstract getWMSFormatter();
}
